import { useState, useEffect } from 'react';

/**
 * Hook to detect prefers-reduced-motion preference.
 * Returns true if user prefers reduced motion.
 * Per Emil Kowalski's standards: reduced motion means fewer/gentler animations,
 * not zero — keep opacity/color transitions, drop transform-based motion.
 */
export function useReducedMotion() {
  const [prefersReduced, setPrefersReduced] = useState(false);

  useEffect(() => {
    // Check initial state
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    setPrefersReduced(mediaQuery.matches);

    // Listen for changes
    const handler = (event) => setPrefersReduced(event.matches);
    mediaQuery.addEventListener('change', handler);

    return () => mediaQuery.removeEventListener('change', handler);
  }, []);

  return prefersReduced;
}

export default useReducedMotion;